export default {
  title: '费用管理',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '费用代码、费用名称、外部关联信息',
    currency: '币种',
    currencyPlaceholder: '请选择币种',
    status: '状态',
    statusPlaceholder: '选择状态',
    basicFee: '基本费用',
    basicFeePlaceholder: '选择类型',
    transportMode: '运输业务类型',
    transportModePlaceholder: '请选择运输业务类型',
    all: '全部',
    enabled: '启用',
    disabled: '禁用',
    yes: '是',
    no: '否',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addFee: '新增费用',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    edit: '编辑',
    enable: '启用',
    disable: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    feeCode: '费用代码',
    feeNameCn: '费用名称',
    feeNameEn: '费用名称（英文）',
    currency: '币种',
    transportMode: '运输业务类型',
    basicFee: '基本费用',
    billingUnit: '计费单位',
    externalRelatedItem:'外部关联项',
    externalRelationName: '外部关联项名称',
    taxRate: '税率',
    feeCategory: '费用类',
    externalId: '外部系统ID',
    externalSource: '外部系统',
    createdBy: '创建人',
    modifiedBy: '修改人',
    dateCreated: '创建时间',
    dateModified: '修改时间',
    status: '状态',
    operation: '操作',
    dataFormatError: '数据格式错误',
    noData: '-'
  },

  // 表单弹窗
  form: {
    addTitle: '新增费用',
    editTitle: '编辑费用',
    feeCode: '费用代码',
    feeCodePlaceholder: '请输入费用代码，如：DGSBF',
    currency: '币种',
    currencyPlaceholder: '请选择币种',
    transportMode: '运输业务类型',
    transportModePlaceholder: '请选择运输业务类型',
    feeNameCn: '费用名称（中文）',
    feeNameCnPlaceholder: '请输入中文费用名称',
    feeNameEn: '费用名称（英文）',
    feeNameEnPlaceholder: '请输入英文费用名称',
    isBasicFee: '是否为基本费用',
    isBasicFeePlaceholder: '请选择',
    billingUnit: '关联计费单位',
    billingUnitPlaceholder: '请选择计费单位',
    defaultPayable: '默认应付',
    externalVisible: '外部可见',
    defaultUnit: '默认单位',
    defaultUnits: {
      fcl: '海运整箱',
      lcl: '海运拼箱',
      air: '空运',
      preport: '港前',
      lastmile: '尾程',
      rail: '铁路'
    },
    externalRelatedItem: '外部关联项',
    externalRelatedItemPlaceholder: '请输入外部关联项',
    externalRelationName: '外部关联项名称',
    externalRelationNamePlaceholder: '请输入外部关联项名称',
    taxRate: '税率',
    taxRatePlaceholder: '请输入税率（0-100）',

    feeCategory: '费用类',
    feeCategoryPlaceholder: '请选择费用类',
    yes: '是',
    no: '否'
  },

  feeCategory: {
    prePort: '港前',
    mainline: '干线',
    lastMile: '尾程',
    fullJourney: '全程'
  },

  // 币种选项
  currency: {
    CNY: 'CNY - 人民币',
    USD: 'USD - 美元',
    EUR: 'EUR - 欧元',
    JPY: 'JPY - 日元',
    GBP: 'GBP - 英镑',
    HKD: 'HKD - 港币'
  },

  // 确认对话框
  confirm: {
    enableTitle: '确认启用',
    disableTitle: '确认禁用',
    enableContent: '确定要将此费用状态设为启用吗？',
    disableContent: '确定要将此费用状态设为禁用吗？',
    batchEnableTitle: '确认批量启用',
    batchDisableTitle: '确认批量禁用',
    batchEnableContent: '确定要将选中的 {count} 个费用设为启用状态吗？',
    batchDisableContent: '确定要将选中的 {count} 个费用设为禁用状态吗？'
  },

  // 表单验证
  validation: {
    feeCodeRequired: '请输入费用代码',
    feeNameCnRequired: '请输入费用名称（中文）',
    feeNameEnRequired: '请输入费用名称（英文）',
    currencyRequired: '请选择币种',
    isBasicFeeRequired: '请选择是否为基本费用',
    feeCategoryRequired: '请选择费用类',
    transportModeRequired: '干线基本费用请选择运输业务类型',
    externalRelatedItemRequired: '请输入外部关联项',
    externalRelatedItemTooLong: '外部关联项不能超过255个字符',
    externalRelationNameTooLong: '外部关联项名称不能超过255个字符',
    billingUnitRequired: '请选择计费单位',
    externalRelatedItem:'外部关联项超长'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的费用',
    selectToDisable: '请选择要禁用的费用',
    loadError: '数据加载失败',
    currencyLoadError: '加载币种选项失败',
    billingUnitLoadError: '加载计费单位失败',
    statusUpdateSuccess: '费用状态已更新为{status}',
    batchEnableSuccess: '费用状态已批量更新为启用',
    batchDisableSuccess: '费用状态已批量更新为禁用',
    saveSuccess: '费用信息添加成功',
    updateSuccess: '费用信息更新成功',
    relationUpdateError: '费用信息保存成功，但关联关系更新失败',
    relationAddError: '费用信息保存成功，但关联关系添加失败'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用',
    yes: '是',
    no: '否'
  }
}
